import { CatalogProduct, CatalogTreeProduct, CatalogProductDependency } from './../model/CatalogProduct';
import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {
  private url: string
  private headers: HttpHeaders = new HttpHeaders();

  constructor(private http: HttpClient, private authService: AuthenticationService) {
    this.url = "/services/otsc-server/v1/managers/catalog/";
  }

  getLatestReleases(): Observable<HttpResponse<CatalogProduct[]>> {
    let url = this.url + "latestReleases";
    return this.http.get<CatalogProduct[]>(`${url}`, { observe: 'response' });
  }

  getProducts(): Observable<HttpResponse<CatalogTreeProduct[]>> {
    let url = this.url + "getProducts";
    return this.http.get<CatalogTreeProduct[]>(`${url}`, { observe: 'response' });
  }

  getProductVersion(name: string): Observable<HttpResponse<CatalogProduct[]>> {
    let url = this.url + "getProductVersions";
    return this.http.get<CatalogProduct[]>(url,
      {
        observe: 'response',
        params: {
          name: name
        }
      });
  }

  getDependencies(uid: string): Observable<HttpResponse<Record<string, CatalogProductDependency[]>>> {
    let url = this.url + "version/dependencies";
    return this.http.get<Record<string, CatalogProductDependency[]>>(url,
      {
        observe: 'response',
        params: {
          uid: uid
        }
      });
  }

  getBinaryDependencies(uid: string): Observable<HttpResponse<Record<string, CatalogProductDependency[]>>> {
    let url = this.url + "binary/dependencies";
    return this.http.get<Record<string, CatalogProductDependency[]>>(url,
      {
        observe: 'response',
        params: {
          uid: uid
        }
      });
  }

  getDownloadInfo(isBundle: boolean, platform: string, uid: string): Observable<any> {
    let url = this.url + "downloadinfo";
    return this.http.get<any>(url,
      {
        observe: 'response',
        params: {
          isBundle: isBundle.toString(),
          platform: platform,
          uid: uid
        }
      });
  }

}
